import BaseModelAPI from '../BaseModelAPI';

export default class BillOfMaterialDetail extends BaseModelAPI {
	static entity = 'billofmaterialdetail';
	static entityName = 'billofmaterialdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.billOfMaterialId = '';
			this.billOfMaterial = {};
			this.id = '';
			this.partNumberId = '';
			this.partNumber = {};
			this.partName = '';
			this.usedQty = 0;
			this.uom = '';
			this.partPriceId = '';
			this.partPrice = {};
			this.priceProduct = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}